import React, { Component } from 'react';
import { connect } from 'react-redux'
import withAuth from '../../../components/Services/WithAuth';
import { Col } from 'reactstrap'
import { setPageView } from '../../../components/GoogleAnalytics/index';
import { getAllDefaultProduct, setSelectedDefaultProduct } from './action';
import Table from '../../../components/UI/Table/Table'
import { Link } from "react-router-dom";
import withRouter from '../../../withRouter';

class Defaultproduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productData: [],
      loading: true,
      editProductFlag: true,
      productDataCount: 0,
      table_columns:[
        {
          Header: "Default Product Name",
          id: "productname",
          accessor: p => <p className="text-truncate" style={{ maxWidth: '350px' }}>{p.productName}</p>
        },
        {
          Header: "counterpartyType",
          id: "counterpartyType",
          maxWidth: 200,
          accessor: p => <div>{p.counterpartyType}</div>,
      
        },
        {
          Header: "Product Category",
          id: "category",
          maxWidth: 200,
          accessor: p => <div>{p.productCategory}</div>,
          className: 'center'
        },
        {
          Header: "Edit",
          id: "Edit",
          maxWidth: 150,
          accessor: p => <Link onClick={() => this.handleEditClick(p)} id={p.id} to={{ pathname: `/corporate/defaultProduct/edit/${p.id}`, state: p }}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></Link>,
        },
      
      ],
      selectedDefaultProduct:null
    };
  }

  componentDidMount() {
    setPageView('/Admin/corporate/defaultProduct', document.location.href)
    this.props.getAllDefaultProduct();
  }

  componentDidUpdate(prevProps) {
    if (this.props.allDefaultProduct !== prevProps.allDefaultProduct) {
        this.setState({
            productData: this.props.allDefaultProduct,
            loading: false
        });
    }
}

handleEditClick(element){
this.props.history.push({
  pathname: `/corporate/defaultProduct/edit/${element.id}`,
  state: element
});
this.props.setSelectedDefaultProduct(element);
}


  render() {
    return (

      <Col>
        <Table
          data={this.props.allDefaultProduct}
          columns={this.state.table_columns}
          className=""
          defaultPageSize={10}
          noDataText="No Default product Available"
        // loading={this.state.loading}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  allDefaultProduct: state.allDefaultProduct.defaultProductListSuccess,
  selectedDefaultProduct: state.allDefaultProduct.selectedDefaultProduct
})

const mapDispatchToProps = (dispatch, props) => ({
  getAllDefaultProduct: () => dispatch(getAllDefaultProduct()),
  setSelectedDefaultProduct: (data) => dispatch(setSelectedDefaultProduct(data))
});

export default withRouter(withAuth(connect(mapStateToProps, mapDispatchToProps)(Defaultproduct)))
